<template>
    <div>
        <div
            class="bo-context-menu"
            :style="[
                {
                    display: 'block',
                    top: popupTop + 'px',
                    left: popupLeft + 'px',
                },
            ]"
            v-if="showPopup == true"
            v-click-outside="hidePopup"
        >
            <div
                class="context-item"
                @click="
                    showModal = true;
                    hidePopup($event);
                "
            >
                <div class="item-command">
                    <span>Advanced Search</span>
                </div>

                <div class="item-hints">
                    <i class="icon-chevronright"></i>
                </div>
            </div>
        </div>

        <!-- modal -->
        <template v-if="showModal">
            <div class="modal-backdrop fade show"></div>
            <div
                class="modal bo-modal fade show"
                style="display: block"
                id="modal-advanced-search"
            >
                <div
                    class="modal-dialog modal-dialog-centered"
                    role="document"
                >
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="modal-title">Advanced Search</div>
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                @click="closeModal"
                            >
                                <i class="icon-close"></i>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="search-setting">
                                <div class="bo-tag mb-4">
                                    <div class="bootstrap-tagsinput">
                                        <template v-for="(search_value, search_index) in searches">
                                            <span
                                                :key="search_index"
                                                class="tag label label-info"
                                                v-if="searchRange(search_value) != ''"
                                            >
                                                {{ searchRange(search_value) }}
                                                <span
                                                    data-role="remove"
                                                    @click="removeSearch(search_index)"
                                                ></span>
                                            </span>
                                        </template>
                                    </div>
                                </div>

                                <div class="setting-frame">
                                    <ol>
                                        <li
                                            v-for="(search_value, search_index) in searches"
                                            :key="search_index"
                                        >
                                            <div class="input-group-frame">
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    v-model="search_value[0]"
                                                />
                                                <span class="pl-2 pr-2"> - </span>
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    v-model="search_value[1]"
                                                />
                                                <i
                                                    class="remove icon-deleteforever delete-single-setting"
                                                    @click="removeSearch(search_index)"
                                                ></i>
                                            </div>
                                        </li>
                                    </ol>

                                    <button
                                        id="btn-add-search"
                                        class="btn-rounded dashed arclight"
                                        @click="addSearch"
                                    >
                                        <i class="icon-addcircle"></i>
                                        <span>Add</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="modal-footer d-flex justify-content-between">
                            <div class="selections">
                                <!-- <div class="total-selected">
                  <div>Total Selected</div>
                  <div class="total-counts" style="">0 Items</div>
                </div> -->
                            </div>
                            <div class="buttons">
                                <button
                                    type="button"
                                    data-dismiss="modal"
                                    class="btn btn-rounded light"
                                    @click="clearSearches"
                                >
                                    Clear All
                                </button>
                                <button
                                    type="button"
                                    data-dismiss="modal"
                                    class="btn btn-rounded light"
                                    @click="closeModal"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    data-dismiss="modal"
                                    class="btn btn-rounded arclight"
                                    @click="applySearch"
                                >
                                    Apply
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import vClickOutside from "v-click-outside";
Vue.use(vClickOutside);

export default {
    props: ["parentId", "popupLeft", "popupTop", "showPopup"],

    data() {
        return {
            totalProducts: 0,
            showModal: false,
            selectSingleProduct: true,
            withoutProductAdvanceSearch: true,
            tempSelectedProduct: "",
            selectedProduct: "",
            searches: [],
            searchResult: [],
        };
    },

    methods: {
        hidePopup($event) {
            if (this.parentId != $event.target.id) {
                this.$emit("hidePopup");
            }
        },

        addSearch() {
            this.searches.push(["", ""]);
        },

        removeSearch(search_index) {
            this.searches.splice(search_index, 1);
        },

        searchRange(search_value) {
            var res = search_value.filter((val) => val !== undefined && val !== null && val !== "");
            if (0 == res.length) {
                return "";
            } else if (2 == res.length) {
                return res[0] + " - " + res[1];
            } else {
                return res[0];
            }
        },

        clearSearches() {
            this.searches = [];
        },

        closeModal() {
            this.showModal = false;
        },

        applySearch() {
            this.$emit("advanceSearch", this.searches);
            this.closeModal();
        },
    },
};
</script>
